













import { Vue, Component, Prop, Ref, Watch } from "vue-property-decorator";
import FileUpload from "./FileUpload.vue";
import FileAuth from "./FileAuth.vue";
import { FILE_PROPERTY_TYPE } from "./config";
@Component({
  name: "FileEntry",
  components: { FileUpload, FileAuth }
})
export default class FileEntry extends Vue {
  @Prop({
    required: true
  })
  config!: App.WebForm.ServiceOriginConfig;

  @Ref("component")
  private component!: {
    getFormValues(): Promise<any>;
  };

  private main: {
    propertyName: string;
    result: { type: string; value: string; object: any };
  } = {
    propertyName: "",
    result: {
      type: "",
      value: "",
      object: {}
    }
  };

  private form: { [prop: string]: { type: string; value: string } } = {};

  private properties: Array<{
    description: string;
    propertyName: string;
    reserved: boolean;
    propertyType: string;
  }> = [];

  get isEmpty() {
    return !this.main.result.value;
  }

  onUploaded(fileId: string) {
    this.form[this.main.propertyName].value = fileId;
  }

  async getFormValues() {
    return await this.component.getFormValues();
  }

  @Watch("config", { immediate: true, deep: true })
  onConfigChange() {
    const formRender = JSON.parse(this.config.formRenderData);
    this.properties = formRender.properties;
    this.properties.forEach((d) => {
      this.form[d.propertyName] = {
        value: this.config.results[d.propertyName].value || "",
        type: d.propertyType
      };
      if (d.propertyType === FILE_PROPERTY_TYPE) {
        this.main.propertyName = d.propertyName;
        if (this.config.results && this.config.results[d.propertyName]) {
          this.main.result = this.config.results[d.propertyName] as any;
        } else {
          this.main.result = { type: "", value: "", object: {} };
        }
      }
    });
  }
}
